module.exports = __webpack_public_path__ + "static/media/stopwatch.dbabcd59.jpeg";